import PropTypes from 'prop-types';
import React from 'react';
import {
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';

import {SidebarContext} from './Sidebar.jsx';

/**
 * Sidebar item for use as an item in the Sidebar component
 */
export const SidebarItem = ({
  label,
  Icon,
  active,
  component = Link,
  href,
  ...props
}) => {
  const sidebarContext = React.useContext(SidebarContext);
  const {open} = sidebarContext;

  return (
    <ListItem
      disablePadding
      sx={{
        display: 'block',
      }}
    >
      <Tooltip title={open ? '' : label} placement="right" arrow>
        <ListItemButton
          component={component}
          to={href}
          selected={open && active}
          sx={{
            minHeight: 48,
            justifyContent: open ? 'initial' : 'center',
            gap: open ? 2 : 0,
            paddingX: 1.5,
            borderRadius: 1,
          }}
          {...props}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              justifyContent: 'center',
              color: active ? 'primary.main' : 'action.active',
            }}
          >
            <Icon />
          </ListItemIcon>
          <ListItemText
            sx={{
              opacity: open ? 1 : 0,
            }}
            primary={label}
          />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};

SidebarItem.propTypes = {
  /**
   * The label for the sidebar item
   */
  label: PropTypes.string.isRequired,
  /**
   * The icon for the sidebar item
   */
  Icon: PropTypes.elementType.isRequired,
  /**
   * Whether the sidebar item is active
   */
  active: PropTypes.bool,
  /**
   * The component to use for the sidebar link
   */
  component: PropTypes.elementType,
  /**
   * The href for the sidebar item Link
   */
  href: PropTypes.string,
};

export default SidebarItem;
